import updateBasket from './updateBasket';

export default (update) => {
  if (update?.metadata?.context.startsWith('basket')) {
    return updateBasket(update);
  }
  throw Error('Not yet implemented');
};
